export default __webpack_public_path__ + "static/media/case2-logo.c6a4a67e.webp";